import { Grant, GrantContext, GrantResult, UserPrivilegeMap } from '../types';

export class PrivilegeGrant implements Grant {
  constructor(
    public readonly privilege: string,
    private userPrivilegeMap?: UserPrivilegeMap
  ) {}

  async allowed(context: GrantContext): Promise<GrantResult> {
    if (!context.facilityId || !this.userPrivilegeMap) {
      return undefined;
    }

    const facilityPrivileges = this.userPrivilegeMap.get(context.facilityId);

    if (!facilityPrivileges) {
      return false;
    }

    return facilityPrivileges.has(this.privilege);
  }

  withPrivilegeMap(userPrivilegeMap: UserPrivilegeMap): PrivilegeGrant {
    return new PrivilegeGrant(this.privilege, userPrivilegeMap);
  }
}
